import React from 'react'
import { Link } from 'react-router-dom'
import '../scss/variables.scss'
import '../scss/reset.scss'
import './Stanze.scss'
import NavbarArrow from '../components/NavbarArrow/NavbarArrow'
import Footer from '../components/Footer/Footer'
import Sidemenu from '../components/Sidemenu/Sidemenu'

import telegramLogo from '../assets/images/TelegramLogo.png'

function Stanze() {
    let arrowPath = "/";

    return (
        <>
            <Sidemenu path1="/chi-siamo" name1="Chi Siamo" path2="/progetto" name2="Il Progetto" path3="/supportaci" name3="Supportaci" path4="/community" name4="Community" />
            <NavbarArrow arrowPath={arrowPath} />
            <main>
                <h1>Scopri le <br />Stanze</h1>
                <div className="rooms">
                    <Link className="single-room" to="/maths">
                        <h2>MATEMATICA</h2>
                    </Link>
                    <Link className="single-room" to="/physics">
                        <h2>FISICA</h2>
                    </Link>
                    
                    <Link className="single-room" to="/it">
                        <h2>INFORMATICA</h2>
                    </Link>
                    
                    <Link className="single-room" to="/english">
                        <h2>INGLESE</h2>
                    </Link>
                    
                    <Link className="single-room" to="/literacy">
                        <h2>LETTERE</h2>
                    </Link>
                    
                    <Link className="single-room" to="/others">
                        <h2>ALTRO</h2>
                    </Link>
                    
                </div>

                <h1>Crea o<br />Unisciti</h1>

                <div className="privateRooms">
                    <Link className="single-private-room" to="/create">
                        <h2>CREA</h2>
                    </Link>
                    <Link className="single-private-room" to="/join">
                        <h2>UNISCITI</h2>
                    </Link>
                </div>

                <div className="telegramContainer">
                    <a href="https://t.me/fadymeet" target="_blank" rel="noreferrer" className="telegramLinkWrapper">
                        <div className="telegram">
                            <div className="imgTelegram">
                                <img src={telegramLogo} alt="Telegram" className="telegramLogo" />
                            </div>
                            <div className="titleTelegram">
                                <p>Unisciti al nostro canale Telegram e 
                                programma gli incontri con altre 
                                persone.</p>
                            </div>
                        </div>
                    </a>
                </div>
                
            </main>
            {/* ADSENSE ads */}
            <div className="ad" align="center">
                <script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-3763146420917084"
                crossOrigin="anonymous"></script>
            </div>
            <Footer />
        </>
    )
}

export default Stanze
